export const STYLE_FIELDS = [
  'color',
  'backgroundColor',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'textAlign',
  'lineHeight',
  'letterSpacing',
  'margin',
  'marginTop',
  'padding',
  'width',
  'height',
  'minWidth',
  'maxWidth',
  'minHeight',
  'maxHeight',
  'display',
  'position',
  'top',
  'right',
  'bottom',
  'left',
  'flexDirection',
  'flexGrow',
  'alignSelf',
  'justifyContent',
  'alignItems',
  'flexWrap',
  'gridTemplateColumns',
  'gridTemplateRows',
  'gap',
  'border',
  'borderRadius',
  'boxShadow',
  'opacity',
  'overflow',
  'zIndex',
  'transform',
  'transition',
  'backgroundImage',
  'backgroundSize',
  'backgroundPosition',
  'objectFit',
  'textDecoration',
];

const bootstrapRange = (start, end) => Array.from({ length: end - start + 1 }, (_, index) => start + index);
const bootstrapBreakpoints = ['', 'sm-', 'md-', 'lg-', 'xl-', 'xxl-'];
const spacingClasses = ['m', 'p'].flatMap((prefix) => (
  ['', 't', 'b', 's', 'e', 'x', 'y'].flatMap((side) => (
    bootstrapRange(0, 5).map((size) => `${prefix}${side}-${size}`)
  ))
));
const responsiveColumns = bootstrapBreakpoints.flatMap((breakpoint) => (
  bootstrapRange(1, 12).map((size) => `col-${breakpoint}${size}`)
));

export const BOOTSTRAP_CLASS_SUGGESTIONS = [...new Set([
  'container',
  'container-fluid',
  'container-sm',
  'container-md',
  'container-lg',
  'container-xl',
  'container-xxl',
  'row',
  'col',
  'col-auto',
  'col-12',
  'col-md-6',
  ...responsiveColumns,
  ...bootstrapBreakpoints.flatMap((breakpoint) => [`d-${breakpoint}none`, `d-${breakpoint}block`, `d-${breakpoint}grid`, `d-${breakpoint}flex`]),
  'd-block',
  'd-grid',
  'd-flex',
  'd-inline',
  'd-inline-block',
  'd-inline-flex',
  'position-relative',
  'position-absolute',
  'position-fixed',
  'position-sticky',
  'top-0',
  'top-50',
  'top-100',
  'bottom-0',
  'start-50',
  'start-100',
  'end-0',
  'start-0',
  'translate-middle',
  'w-25',
  'w-50',
  'w-75',
  'w-100',
  'w-auto',
  'mw-100',
  'h-25',
  'h-50',
  'h-75',
  'h-100',
  'h-auto',
  'mh-100',
  'min-vh-100',
  'min-vw-100',
  'vh-100',
  'vw-100',
  'align-items-center',
  'align-items-start',
  'align-items-end',
  'align-items-stretch',
  'align-self-center',
  'align-self-start',
  'align-self-end',
  'justify-content-center',
  'justify-content-between',
  'justify-content-around',
  'justify-content-evenly',
  'justify-content-start',
  'justify-content-end',
  'flex-row',
  'flex-column',
  'flex-wrap',
  'flex-nowrap',
  'flex-fill',
  'flex-grow-1',
  'flex-shrink-0',
  ...bootstrapRange(0, 5).flatMap((size) => [`g-${size}`, `gx-${size}`, `gy-${size}`, `gap-${size}`]),
  'gap-3',
  ...spacingClasses,
  ...['m', 'mt', 'mb', 'ms', 'me', 'mx', 'my'].map((prefix) => `${prefix}-auto`),
  'text-center',
  'text-start',
  'text-end',
  'text-muted',
  'text-body',
  'text-primary',
  'text-secondary',
  'text-success',
  'text-danger',
  'text-warning',
  'text-info',
  'text-light',
  'text-dark',
  'text-white',
  'text-decoration-none',
  'text-uppercase',
  'text-lowercase',
  'text-capitalize',
  'text-wrap',
  'text-nowrap',
  'text-break',
  'lead',
  ...bootstrapRange(1, 6).flatMap((size) => [`display-${size}`, `fs-${size}`]),
  'fw-light',
  'fw-normal',
  'fw-semibold',
  'fw-bold',
  'fst-italic',
  'lh-1',
  'lh-sm',
  'lh-base',
  'lh-lg',
  'bg-primary',
  'bg-secondary',
  'bg-success',
  'bg-danger',
  'bg-warning',
  'bg-info',
  'bg-light',
  'bg-dark',
  'bg-white',
  'bg-transparent',
  'bg-body-tertiary',
  'border',
  'border-0',
  'border-top',
  'border-bottom',
  'border-start',
  'border-end',
  'border-primary',
  'border-secondary',
  'rounded',
  'rounded-0',
  'rounded-1',
  'rounded-2',
  'rounded-3',
  'rounded-circle',
  'rounded-pill',
  'shadow-none',
  'shadow-sm',
  'shadow',
  'shadow-lg',
  'overflow-auto',
  'overflow-hidden',
  'overflow-visible',
  'overflow-scroll',
  'img-fluid',
  'img-thumbnail',
  'btn',
  'btn-primary',
  'btn-secondary',
  'btn-success',
  'btn-danger',
  'btn-warning',
  'btn-info',
  'btn-light',
  'btn-dark',
  'btn-outline-primary',
  'btn-outline-secondary',
  'btn-sm',
  'btn-lg',
  'card',
  'card-body',
  'card-title',
  'card-text',
  'card-img-top',
  'alert',
  'alert-primary',
  'badge',
  'text-bg-primary',
  'list-group',
  'list-group-item',
  'progress',
  'progress-bar',
  'table',
  'table-responsive',
])];

export const isKnownBootstrapClass = (className) => (
  BOOTSTRAP_CLASS_SUGGESTIONS.includes(String(className || '').trim())
);
